<template>
  <v-card flat>
    <v-card-text>
      <v-textarea
        :label="$t('instructions')"
        v-model="instructions"
        rows="3"
        auto-grows
        hide-details
        variant="outlined"
        @change="$nextTick(() => $emit('change', { instructions }))"
      ></v-textarea>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { cloneDeep } from 'lodash-es';
import { ref, onMounted } from 'vue';

const props = defineProps({
  workOrder: {
    type: Object,
    required: true
  }
})

const instructions = ref(null)
const originalWorkOrder = ref(null as any)

onMounted (() => {
  originalWorkOrder.value = cloneDeep(props.workOrder)
  initializeInputs()
})

const initializeInputs = () => {
  instructions.value = originalWorkOrder.value.instructions ?? null
}

defineExpose({
  initializeInputs
});
</script>

